import { UserManager } from 'paycor-oidc-client';
import config from '../config';
let userManager = new UserManager(config.securitySettings);

export async function buildAuthToken() {
	const user = await userManager.getUser();

	return user.access_token;
}
